<template>
  <div class="container">
    <div class="info">
      <!-- 标题 -->
      <div class="title">{{ $t('common').Notice }}</div>
      <!-- 列表 -->
      <div class="listInfo">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`notice${dIndex}`"
          @click="$router.push({ name: 'Detail', query: { id: dItem.contentLocalizationId } })">
          <img class="iiimg" v-if="dItem.image" :src="isHttp(dItem.image) ? dItem.image : baseUrl + dItem.image">
          <img class="iiimg" v-else src="@/assets/img/new_local.jpg">
          <div class="right">
            <div class="name">{{ dItem.localizationTitle }}</div>
            <div class="time">{{ dItem.occurrenceTime }}</div>
            <div class="content " v-html="dItem.localizationContent"></div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagefoot">
          <el-pagination :current-page="parms.pageNum" :page-size="parms.pageSize" layout="prev, pager, next"
            hide-on-single-page :total="total" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import systemApi from '@/api/system'

export default {
  components: {
  },
  data() {
    return {
      baseUrl: window.baseURL,
      parms: {
        pageNum: 1,
        pageSize: 10,
        type: '1'
      },
      oList: [],
      total: 0,
    }
  },
  watch: {
    '$i18n.locale'() {
      this.getContentList(); // 语言变了，重新生成
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getContentList()
  },
  methods: {
    isHttp(url) {
      return /^https?:\/\//.test(url)
    },
    // 切换分页
    handleCurrentChange(val) {
      this.parms.pageNum = val
      this.getContentList()
    },
    // 获取内容列表
    async getContentList() {
      const res = await systemApi.getContentList(this.parms)
      this.oList = res.rows
      this.total = res.total
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .title {
      font-size: 36px;
      font-weight: bold;
      color: var(--text_color);
    }

    .listInfo {
      margin-top: 20px;
      padding-bottom: 80px;

      .item {
        padding: 20px 0;
        background: var(--background_color);
        font-size: 15px;
        display: flex;
        align-items: center;

        .iiimg {
          width: 300px;
          height: 199px;
          border-radius: 10px;
          margin-right: 30px;
        }

        .right {
          max-width: 900px;

          .name {
            font-size: 26px;
            color: var(--text_color);
            line-height: 35px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .time {
            margin-top: 20px;
            font-size: 17px;
            color: var(--ntext_color);
          }

          .content {
            margin-top: 20px;
            font-size: 17px;
            color: var(--ntext_color);
            line-height: 25px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .item:hover {
        background: var(--info_color);
      }

      .pagefoot {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
}

// 分页
::v-deep .el-pagination button {
  color: var(--text_color);
  background-color: var(--background_color);
}

::v-deep .el-pager li {
  background: var(--background_color);
  color: var(--text_color);
}

::v-deep .el-pager li.active {
  color: var(--background_color);
  background: var(--text_color);
  border-radius: 15px;
}
</style>
